module.exports = __webpack_public_path__ + "img/IT.cc79b186.png";